const $$splitComponentImporter = () => import('/home/runner/work/inspecttec-frontend-admin/inspecttec-frontend-admin/src/routes/client/onboarding.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SETUP_STEP_IDS, type SetupStepId } from "@/components/onboarding/setup-steps";
import { Permissions } from "@/constants/permissions";
import { requirePermission } from "@/lib/auth/permission-guard";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
const searchSchema = z.object({
  /** Deep-linkable step (`?step=locations`); unknown values fall back to step 1. */
  step: z.enum(SETUP_STEP_IDS).optional().catch(undefined)
});
export const Route = createFileRoute("/client/onboarding")({
  validateSearch: searchSchema,
  beforeLoad: args => requirePermission(Permissions.Clients.Impersonate, args),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Tenant Setup console (design §5.4 / §6 item 12, Phase 1B): an eight-step
 * stepper in the Sepulveda runbook order — Company & auth → Locations →
 * Asset groups & assets → Users & groups → Checklists → Inspection
 * configurations → Notification recipients → Go-live — each step chip
 * derived from the `setup-status` gates. Steps never block. The pre-existing
 * role-initialisation and ACORD tools plus the Phase 1B reset live under
 * "Advanced".
 */

interface TenantSetupStepperProps {
  clientId: string;
  clientName: string;
}
interface StepBodyProps {
  id: SetupStepId;
  clientId: string;
  /** Exact client name (record when loaded, else the admin store's copy). */
  clientName: string;
  client: Awaited<ReturnType<typeof clientService.getClientById>> | undefined;
  clientLoading: boolean;
}

/**
 * The original onboarding page's actions, kept verbatim in behaviour:
 * "Initialize default roles" (POST /clients/onboard/roles, x-tenant-id) and
 * the ACORD PDF extraction.
 */